import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-765c9b71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "trauma" }, "TRAUMA RESPONSE", -1))
const _hoisted_3 = ["value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("textarea", {
      type: "text",
      class: "plain-text",
      value: _ctx.traumaResponse,
      disabled: !_ctx.editMode,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editTraumaResponse && _ctx.editTraumaResponse(...args))),
      id: "trauma"
    }, null, 40, _hoisted_3)
  ]))
}